export const RQ_GET_INPUT_STOCK_REPORT_API = {
  url: 'inventorystock/stock-report/<%= divisionId%>',
  method: 'GET',
  auth: true,
};
